import AllTextState from "../../../../assets/shared/state/AllTextState"

const NavMiddle = () => {
  return (
    <>
      <span style={{ fontSize: "22px",
        color: "#FFF",
        fontWeight: "200"
      }}>{AllTextState.webName}</span>
    </>
  )
}

export default NavMiddle
